import { Controller } from "@hotwired/stimulus"
import { TooltipService } from "../portal/services/tooltip_service"

export default class extends Controller {
  static targets = ["branchName", "template"]

  connect() {
    this.tooltipService = new TooltipService()
    document.addEventListener("dropdown:setupBranchesTooltips", () => {
      this.setupBranchesTooltips()
    })
  }

  // Detect text overflow and add tooltip if needed
  // Need to hack CSS because ellipsis + flexbox = wrong measurements
  setupBranchesTooltips() {
    this.branchNameTargets.forEach(branchName => {
      const menuItem = branchName.closest(".menu-item")
      if (!menuItem) return

      const originalStyle = menuItem.style.cssText
      menuItem.style.cssText = "position: absolute; visibility: hidden; white-space: nowrap;"

      const scrollWidth = menuItem.scrollWidth
      const clientWidth = menuItem.clientWidth

      menuItem.style.cssText = originalStyle

      if (scrollWidth > clientWidth) {
        const existingTooltip = branchName.parentElement.querySelector(".branch-tooltip")
        if (!existingTooltip) {
          const clonedTemplate = this.templateTarget.content.cloneNode(true)
          const tooltipElement = clonedTemplate.querySelector(".branch-tooltip")
          tooltipElement.textContent = branchName.textContent
          branchName.parentElement.appendChild(clonedTemplate)

          this.tooltipService.setupTooltip(branchName, tooltipElement, {
            leftOffset: "calc(var(--spacing-9) + var(--spacing-05))"
          })
        }
      }
    })
  }
}
